<template>
  <svg
    width="45"
    height="45"
    fill="none"
    viewBox="0 0 45 45"
    style="z-index: 21"
    class="ease-in-out"
    :style="{
      transform: isUp ? 'rotate(180deg)' : 'rotate(0)',
      transition: `transform ${transitionStyle}`,
    }"
  >
    <rect width="45" height="45" rx="22.5" fill="#0D9488" />
    <path
      fill="white"
      d="M13.1354 25.8812L22.9916 16.025L24.9526 17.986L15.0964 27.8422L13.1354 25.8812ZM21.0312 17.985L22.9922 16.0239L32.8484 25.8801L30.8874 27.8412L21.0312 17.985Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isUp: {
      type: Boolean,
      required: true,
    },
    longRotation: {
      type: Boolean,
    },
    transform: {
      type: String,
      default: '0.6s',
    },
  },
  computed: {
    transitionStyle(props) {
      return this.longRotation && this.isUp ? '5s' : props.transform;
    },
  },
};
</script>
<style scoped>
svg rect {
  fill: #0d9488;
}
svg:hover rect {
  fill: #0b7c72;
}
</style>
